import { DomainConf } from "./DomainConfig";

/**
 * Define configurations here to be loaded based on the domain
 * the app is being served from.
 */
const env = new DomainConf()
  .forDomain("localhost", {
    homeUrl: "http://localhost:3000",
    // apiBase: "http://localhost:7071/api",
    apiBase: "https://dev-api.bidpro.com/api/v1",
    localDevMode: true,
  })
  .forDomain("dev.bidpro.com", {
    homeUrl: "https://dev.bidpro.com",
    apiBase: "https://dev-api.bidpro.com/api/v1",
  })
  .forDomain("beta.bidpro.com", {
    homeUrl: "https://beta.bidpro.com",
    apiBase: "https://api.bidpro.com/v1/bidpro",
  })
  .forDomain("www.bidpro.com", {
    homeUrl: "https://www.bidpro.com",
    apiBase: "https://api.bidpro.com/v1/bidpro",
  });
// Export the selected configuration from this file. You can import this wherever you need to use it.
export default env.current;
